import Header from "@/components/Header";
import Hero from "@/components/Hero";
import IndustriesFilmstrip from "@/components/IndustriesFilmstrip";
import ValueProp from "@/components/ValueProp";
import FounderStrip from "@/components/FounderStrip";
import Capabilities from "@/components/Capabilities";
import Offerings from "@/components/Offerings";
import InsightsSection from "@/components/InsightsSection";
import ProofStandard from "@/components/ProofStandard";
import MetricsMarquee from "@/components/MetricsMarquee";
import ContactFooter from "@/components/ContactFooter";

export default function LandingPage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <IndustriesFilmstrip />
        <ValueProp />
        <FounderStrip />
        <Capabilities />
        <Offerings />
        <ProofStandard />
        <InsightsSection />
        <MetricsMarquee />
        <ContactFooter />
      </main>
    </>
  );
}
